import Vue from 'vue'
import Vuex from 'vuex'
import types from "@/config/index";
import api from "@/api";

Vue.use(Vuex);
const state = {
  token: localStorage.getItem('token'), //登录token
  timeout: localStorage.getItem('timeout'), //过期时间
  topmenu: localStorage.getItem('topmenu'), //一级导航
  userinfo: localStorage.getItem('userinfo'), //用户信息
  topnav: localStorage.getItem('topnav'), //顶部导航选中项
  leftnav: localStorage.getItem('leftnav'), //左侧导航选中项
  courseinfo: localStorage.getItem('courseinfo'), //课程信息
  sideBar: true,//是否展示左边栏
  role:localStorage.getItem('role'),//1 admin 2 business
  showFlag:localStorage.getItem('showFlag')||false,
  gradeList:[],
  classList:[],
  course:[],
  Info:localStorage.getItem('Info')
};
const mutations = {
  [types.UPDATE_TOKEN](state, payload) { // 设置token
      if (payload.token) {
          state.token = payload.token
          localStorage.setItem('token', payload.token)
      }
  },
  [types.REMOVE_TOKEN](state) { // 清除token
      state.token = localStorage.removeItem('token')
  },
  [types.UPDATE_TIMEOUT](state) { // 设置过期时间
      const time = new Date().getTime()
      state.timeout = time
      localStorage.setItem('timeout', time)
  },
  [types.REMOVE_TIMEOUT](state) { // 清除过期时间
      state.timeout = localStorage.removeItem('timeout')
  },
  [types.UPDATE_TOPMENU](state, payload) { // 获取顶部导航列表
      if (payload) {
          let menu = JSON.stringify(payload)
          state.topmenu = menu
          localStorage.setItem('topmenu', menu)
      }
  },
  [types.REMOVE_TOPMENU](state) { // 清除顶部导航列表
      state.topmenu = localStorage.removeItem('topmenu')
  },
  [types.UPDATE_LEFTNAV](state, payload) { // 获取左侧导航选中项
      if (payload) {
          // let leftnav = JSON.stringify(payload)
          state.leftnav = payload
          localStorage.setItem('leftnav', payload)
      }
  },
  [types.REMOVE_LEFTNAV](state) { // 清除左侧导航选中项
      state.leftnav = localStorage.removeItem('leftnav')
  },
  [types.UPDATE_TOPNAV](state, payload) { // 获取顶部导航选中项
      if (payload) {
          // let topnav = JSON.stringify(payload)
          state.topnav = payload
          localStorage.setItem('topnav', payload)
      }
  },
  [types.REMOVE_TOPNAV](state) { // 清除顶部导航选中项
      state.topnav = localStorage.removeItem('topnav')
  },
  [types.UPDATE_USERINFO](state, payload) { // 设置用户信息
      if (payload) {
          let info = JSON.stringify(payload)
          state.userinfo = info
          localStorage.setItem('userinfo', info)
      }
  },
  [types.REMOVE_USERINFO](state) { // 清除用户信息
      state.userinfo = localStorage.removeItem('userinfo')
  },
  [types.UPDATE_COURSEINFO](state, payload) { // 设置课程信息
      if (payload) {
          let info = JSON.stringify(payload)
          state.courseinfo = info
          localStorage.setItem('courseinfo', info)
      }
  },
  [types.REMOVE_COURSEINFO](state) { // 清除课程信息
      state.courseinfo = localStorage.removeItem('courseinfo')
  },
  [types.LOGIN_OUT]() { // 退出
      this.commit('REMOVE_TOKEN') //清除token
      this.commit('REMOVE_USERINFO') //登录用户信息
      this.commit('REMOVE_TOPMENU') //清除顶部导航列表
      this.commit('REMOVE_TOPNAV') //清除顶部选中导航
      this.commit('REMOVE_LEFTNAV') //清除左侧选中导航
      this.commit('REMOVE_COURSEINFO') //清除课程信息
      this.commit('REMOVE_TIMEOUT') //清除过期时间
  },
  SIDEBAR(state, payload){
    state.sideBar = payload;
  },
  SHOWFLAG(state, payload){
    state.showFlag = payload;
  },
  ROLE(state, payload){ 
    localStorage.setItem('role', payload)
    state.role = payload;
  },
  GRADELIST(state, payload){
    state.gradeList = payload;
  },
  CLASSLIST(state, payload){
    state.classList = payload;
  },
  COURSE(state, payload){
    state.course = payload;
  },
  INFO(state, payload){ 
    state.Info = JSON.parse(payload); 
  },

};
const actions = {

  // 获取年级班级
  GetGradeLists({ commit },data) {
    return new Promise((resolve, reject) => {
      api.getSchoolList(data)
        .then(response => {
        //   if (!response.error) {
            let result = response.data.rtdata;
            commit('GRADELIST', result)
            resolve(result)
        //   } else {
        //     reject(response.error)
        //   }
        }).catch(error => {
          reject(error)
        })
    })
  },
  // 获取课程分类
  GetCourseLists({ commit },data) {
    return new Promise((resolve, reject) => {
      api.getCourseList(data)
        .then(response => {
        //   if (!response.error) {
            let result = response.data.rtdata;
            commit('COURSE', result)
            resolve(result)
        //   } else {
        //     reject(response.error)
        //   }
        }).catch(error => {
          reject(error)
        })
    })
  },
    // 获取年级班级
    GetClassLists({ commit },data) {
        return new Promise((resolve, reject) => {
            api.getSchoolclass(data)
            .then(response => {
            //   if (!response.error) {
                let result = response.data.rtdata;
                commit('CLASSLIST', result)
                resolve(result)
            //   } else {
            //     reject(response.error)
            //   }
            }).catch(error => {
                reject(error)
            })
        })
    },

  loginAfterValue({ commit }, data) { //登录之后操作
      try {
          commit('UPDATE_TOKEN', { token: data }) // 设置token
          commit('UPDATE_TIMEOUT') // 设置过期时间
      } catch (error) { 
      }
  },
  clearLogin({ commit }) { //清除登录操作
      try {
          commit('REMOVE_TOKEN') // 清除token
          commit('REMOVE_TIMEOUT') // 清除过期时间
      } catch (error) { 
      }
  },
  clearNav({ commit }) { //清除导航选中
      try {
          commit('REMOVE_TOPNAV') //清除顶部选中导航
          commit('REMOVE_LEFTNAV') //清除左侧选中导航
      } catch (error) { 
      }
  },
//   sideBar({commit}){}
};
const getters = {
  token: state => state.token,
  timeout: state => {
      //当前时间
      let now = new Date().getTime()

      //过期时间（默认5小时）
      let timeout = 5 * 60 * 1000

      //如果时间过期
      if (now - state.timeout > timeout) {
          return 0
      } else {
          return now - state.timeout
      }
  },
  topmenu: state => state.topmenu,
  userinfo: state => state.userinfo,
  topnav: state => state.topnav,
  leftnav: state => state.leftnav,
  courseinfo: state => state.courseinfo,
  sideBar:state=> state.sideBar,
  role:state=> state.role,
  showFlag:state=> state.showFlag,
  gradeList:state=> state.gradeList,
  course:state=> state.course,
  Info:state=> state.Info,

};
// 退出删除用户状态
const delUserStatus = (commit) => {
  // 删除用户信息TOKEN
  storage.removeItem(CONFIG.TOKEN)
  // 删除时间 
  storage.removeItem(CONFIG.LAST_LOGIN_TIME)
  storage.removeItem(CONFIG.USERROLE)
  // 清除 权限store
  commit('SET_ROLES', [])
  // 清除 用户信息
  commit('SET_USERINFO', null)
  // 清除 添加的路由
  commit('SET_ROUTERS', [])
  // 跳转入登录页
  // return
  router.replace({ path: '/login' })
} ;

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters
})



// WEBPACK FOOTER //
// ./src/store/index.js